module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKBAMAAABLZROSAAAAFVBMVEW7u7tHcEy7u7u7u7u7u7u7u7u7u7vqzGrpAAAAB3RSTlMwABDP32BAJj1+4gAAAD9JREFUCB0FwcENgCAUBbCHYQD6D55NWEHujCD7L2ObG3BlHjB2aoHeYh6MLWqhN2EeYxNq6Y1gfhtBvQ2BB36etAgslBvlugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/down.png
// module id = qfnN
// module chunks = 37